// Author THQ
// Date 2025-04-09 17:42:53

import * as model from "@/model/em/ppe/PpeDeptManagerDictModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PpeDeptManagerDict(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_PPE_URL,
    })
    .buildStore()
